import React from 'react';
import { Container } from '../style';
import { useTranslation } from 'react-i18next';

const Subsection = ({ title, list }) => {
  return (
    <div className="article__subsection">
      <h3 className="article__subsection-title">{title}</h3>
      <ul className="list">
        {Array.isArray(list) ? (
          list.map((item, index) => (
            <li className="list__item" key={index}>
              {item}
            </li>
          ))
        ) : (
          <li className="list__item">No items available</li>
        )}
      </ul>
    </div>
  );
};

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <br />
      <br />
      <br />
      <article className="article">
        <h1 className="article__header">{t("header")}</h1>
        <p className="article__intro">{t("intro")}</p>

        <section className="article__section">
          <h2 className="article__section-title">{t("mainDirections")}</h2>

          {/* Секция 1: Защита интересов банков */}
          <Subsection
            title={t("protectionOfInterests")}
            list={t("protectionOfInterestsList", { returnObjects: true })}
          />

          {/* Секция 2: Содействие развитию банковской системы */}
          <Subsection
            title={t("developmentOfBankingSystem")}
            list={t("developmentOfBankingSystemList", { returnObjects: true })}
          />

          {/* Секция 3: Повышение квалификации банковских работников */}
          <Subsection
            title={t("qualificationImprovement")}
            list={t("qualificationImprovementList", { returnObjects: true })}
          />

          {/* Секция 4: Информационная поддержка и взаимодействие с обществом */}
          <Subsection
            title={t("informationSupport")}
            list={t("informationSupportList", { returnObjects: true })}
          />

          {/* Секция 5: Сотрудничество с международными финансовыми организациями */}
          <Subsection
            title={t("internationalCooperation")}
            list={t("internationalCooperationList", { returnObjects: true })}
          />
        </section>

        <p className="article__conclusion">{t("conclusion")}</p>
      </article>
      <br />
      <br />
      <br />
    </Container>
  );
};

export default AboutUs;
